module.exports = "/_next/static/images/1061d0f7cd115bba3e6ec6572d05673b-circles.svg.webp";